import { config } from "config";
import { SetDeliveryCarExtrasPayload, DeliveryCarExtraState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const default_page_size = config.PAGE_SIZE;
const initialState: DeliveryCarExtraState = {
  totalCount: 0,
  deliveryCarExtras: [],
  deliveryCarExtra: null,
  loading: true,
  exportCSVLoading: false,
  csvMessage: null,
  refresh: 0,
  refreshLoader: false,
  current_filters: {},
  deliveryCarExtraOptions: [],
  filters: { page: 1, pageSize: default_page_size },
};

export const deliveryCarExtraSlice = createSlice({
  name: "deliveryCarExtra",
  initialState,
  reducers: {
    clear: (state) => {
      state.deliveryCarExtraOptions = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setExportCSVLoading: (state, action: PayloadAction<boolean>) => {
      state.exportCSVLoading = action.payload;
    },
    addCarExtra: (state, action) => {
      state.deliveryCarExtras.unshift(action.payload);
    },
    updateCarExtra: (state, action) => {
      const { id, extra } = action.payload;
      state.deliveryCarExtras.every(({ _id }, i) => {
        if (id === _id) {
          state.deliveryCarExtras[i] = extra;
          return false;
        }
        return true;
      });
    },
    deleteCarExtraById: (state, action) => {
      const id = action.payload;
      state.deliveryCarExtras.every(({ _id }, i) => {
        if (id === _id) {
          state.totalCount -= 1;
          state.deliveryCarExtras.splice(i, 1);
          return false;
        }
        return true;
      });
    },
    setCarExtra: (state, action) => {
      state.deliveryCarExtra = action.payload;
    },
    setCarExtras: (
      state,
      action: PayloadAction<SetDeliveryCarExtrasPayload>
    ) => {
      const { totalCount, deliveryCarExtras } = action.payload;
      state.totalCount = totalCount;
      state.deliveryCarExtras = deliveryCarExtras;
    },
    setPage: (state, action: PayloadAction<{ page: number }>) => {
      const { page } = action.payload;
      state.filters.page = page;
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
    setCsvMessage: (
      state,
      action: PayloadAction<{
        message: string;
        type: "success" | "error" | "warning" | "info";
      } | null>
    ) => {
      state.csvMessage = action.payload;
    },
    setOptions: (state, action) => {
      state.deliveryCarExtraOptions = action.payload;
    },
  },
});

const deliveryCarExtraReducer = deliveryCarExtraSlice.reducer;

export const deliveryCarExtraActions = deliveryCarExtraSlice.actions;
export default deliveryCarExtraReducer;
